<template>
  <v-dialog v-model="saveDialog" persistent max-width="75%">
    <v-form
      ref="form"
      lazy-validation
    >
    <v-card>
      <v-card-title style="background-color: #2b3990">
        <span class="headline white--text">{{ titleForm }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          
          <v-row>
            <v-col cols="12" sm="12" xs="12" md="6">
              <v-datetime-picker
                ref="newClockIn"
                v-model="ClockIn"
                time-format="hh:mm a"
                date-format="yyyy-MM-dd"
                label="Clock In"
              ></v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="12" xs="12" md="6">
              <v-datetime-picker
                    ref="newClockOut"
                    v-model="ClockOut"
                    time-format="hh:mm a"
                    date-format="yyyy-MM-dd"
                    label="Clock Out"
                  ></v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="12" xs="12" md="6">
              <v-text-field
                ref="newLocationInStreet"
                v-model="LocationInStreet"
                label="Location In Street"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" xs="12" md="6">
              <v-text-field
                ref="newLocationOutStreet"
                v-model="LocationOutStreet"
                label="Location Out Street"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                ref="note"
                v-model="Note"
                clearable
                clear-icon="mdi-close-circle"
                label="Notes"
                required
                :rules="[v => !!v || 'Note is Required']"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text v-if="action==='update'" @click="callUpdates()"
        >Update</v-btn>
         <v-btn color="blue darken-1" text v-if="action==='add'" @click="addTimesheet()"
        >Save</v-btn>
        <v-btn color="blue darken-1" text @click="close()"
        >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { mapState, mapMutations } from "vuex";
  const TimesheetService = require("../../service/timesheet.service");
  import moment from "moment";

  export default {
    props: {
      titleForm: String,
      timesheet: Object,
      getTimeSheets: Function,
      action: String,
    },

    data: () => ({
      ClockIn: null,
      ClockOut: null,
      Note: "",
      LocationInStreet: "",
      LocationOutStreet: "",
    }),

    watch: {
      newClockOut: async function(val){
        this.ClockOut = val;
        if(val === null){
          this.$refs.newClockOut.clearHandler(); //CLEAR DATETIMEVALUE
        }
      },

      newClockIn: async function(val){
        this.ClockIn = val;
        if(val === null){
          this.$refs.newClockIn.clearHandler(); //CLEAR DATETIMEVALUE
        }
      },

      newNote: async function(val){
        this.Note = val;
        if(val === "" || val === undefined){
          this.$refs.note.reset();
        }
      },

      newLocationInStreet: async function(val){
        this.LocationInStreet = val;
        if(val === "" || val === undefined){
          this.$refs.newLocationInStreet.reset();
        }
      },

      newLocationOutStreet: async function(val){
        this.LocationOutStreet = val;
        if(val === "" || val === undefined){
          this.$refs.newLocationOutStreet.reset();
        }
      }

    },

    computed: {
      ...mapState({
        saveDialog: state => state.timesheet.saveDialog,
        timeSheet: state => state.timesheet.timeSheet,
      }),   

      newNote:{
        set(value){
          this.Note = value;
        },
        get(){
          return this.timeSheet.Note;
        }
      },

      newClockIn: {
        set(value){
          this.ClockIn = value;
        },
        get(){
          if(this.timeSheet.ClockIn !== undefined){
            return (this.timeSheet.ClockIn == "") ? null : moment(new Date(this.timeSheet.ClockIn)).format("YYYY-MM-DD hh:mm a");
          } 
          return null;
        },
      },
      
      newClockOut: {
        set(value){
          this.ClockOut = value;
        },
        get(){
          if(this.timeSheet.ClockOut !== undefined){
            return (this.timeSheet.ClockOut == "") ? null : moment(new Date(this.timeSheet.ClockOut)).format("YYYY-MM-DD hh:mm a");
          }else{
            return null;
             
          }
         
        },
      },

      newLocationInStreet:{
        set(value){
          this.LocationInStreet = value;
        },
        get(){
          return this.timeSheet.LocationInStreet;
        }
      },

      newLocationOutStreet:{
        set(value){
          this.LocationOutStreet = value;
        },
        get(){
          return this.timeSheet.LocationOutStreet;
        }
      },

      
    },

    async created(){
    },

    methods: {
      ...mapMutations({
        setSnackbar: "SET_SNACKBAR",
      }),

      ...mapMutations("timesheet", {
        setSaveDialog: "SET_SAVE_DIALOG",
      }),

      callUpdates() {
        let req_body = "";
        if (this.$refs.form.validate()) {
          const ClockIn = moment(moment(new Date(this.ClockIn)).format("YYYY-MM-DD hh:mm a")).utc();
          const ClockOut = (this.ClockOut !== "" && this.ClockOut !== null) ?  moment(moment(new Date(this.ClockOut)).format("YYYY-MM-DD hh:mm a")).utc() : "";
    
          if (
              ClockIn != "Invalid Date" && 
              ClockOut == ""
          ) {
            req_body = {
              ClockIn: ClockIn,
              LocationInStreet: this.LocationInStreet,
              LocationOutStreet: this.LocationOutStreet,
              timesheetID: this.timeSheet._id,
              Note: this.Note,
            };
            this.updateTimeSheet(req_body);
          
          } else if(ClockIn != "Invalid Date" && ClockOut != "" && ClockOut != null && ClockOut.isAfter(ClockIn)){
            req_body = {
              ClockIn: ClockIn,
              ClockOut: ClockOut,
              Note: this.Note,
              timesheetID: this.timeSheet._id,
              LocationInStreet: this.LocationInStreet,
              LocationOutStreet: this.LocationOutStreet,
            };
            this.updateTimeSheet(req_body);
          } else {
            // Give out proper prompt
            alert("Invalid Dates placed.");
          }
        }
      },

      updateTimeSheet(req_body) {
        TimesheetService.update(req_body.timesheetID, req_body)
          .then((response) => {
            this.getTimeSheets();
            if (response.status == 400) {
              response.json().then(function(data) {
                alert(data.msg);
              });
            }
            this.setSnackbar({
              show: true,
              text: "The time sheet has been updated successfully.",
              color: "green accent-4",
            });
            
          });
        this.close();
      },

      addTimesheet(){
        const ClockIn = moment(new Date(this.newClockIn)).utc().format("YYYY-MM-DD hh:mm a");
        const ClockOut = moment(new Date(this.newClockOut)).utc().format("YYYY-MM-DD hh:mm a");
        if (this.$refs.form.validate()) {
          if(ClockIn != "Invalid Date" && ClockOut != "" && ClockOut != null && ClockOut > ClockIn){
            const req_body = {
              ClockIn: ClockIn,
              ClockOut: ClockOut,
            };

            console.log(req_body);
            this.setSnackbar({
              show: true,
              text: "Success!",
              color: "green accent-4",
            });
          }else{
            this.setSnackbar({
              show: true,
              text: "Invalid Dates",
              color: "red accent-4",
            });
          }

          this.close();
        }
      },

      close(){
        this.setSaveDialog(false);
      },
    },

  }
</script>